import {
  GiftDeliveryForAdmin,
  GiftDeliveryOrderInfo,
} from '@shared/api/giftDelivery/giftDelivery.interface';
import { GiftItemForStore } from '@shared/api/giftItem/giftItem.interface';
import { fileBucketUrl } from '@shared/utils/fileUtils';

export const formatDateTime = (date: Date | string | undefined) => {
  if (!date) return '-';
  const d = new Date(date);
  const y = String(d.getFullYear()).slice(2);
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  const h = String(d.getHours()).padStart(2, '0');
  return `${y}.${m}.${day} ${h}시`;
};

export const formatDate = (date: Date | string | undefined) => {
  if (!date) return '-';
  const d = new Date(date);
  const y = String(d.getFullYear()).slice(2);
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}.${m}.${day}`;
};

export const toLocalDateTimeString = (date: Date = new Date()) => {
  const offset = date.getTimezoneOffset();
  const local = new Date(date.getTime() - offset * 60 * 1000);
  return local.toISOString().slice(0, 16);
};

export const formatPhone = (phone: string | undefined) => {
  if (!phone) return '-';
  if (phone.length === 11)
    return `${phone.slice(0, 3)}-${phone.slice(3, 7)}-${phone.slice(7)}`;
  if (phone.length === 10)
    return `${phone.slice(0, 3)}-${phone.slice(3, 6)}-${phone.slice(6)}`;
  return phone;
};

export const getItemName = (delivery: GiftDeliveryForAdmin): string => {
  if (typeof delivery.giftItem === 'object') {
    const item = delivery.giftItem as GiftItemForStore;
    return item.name || (item.giftItemInfo as any)?.name || '-';
  }
  return '-';
};

export const getImageUrl = (delivery: GiftDeliveryForAdmin): string => {
  if (typeof delivery.giftItem === 'object') {
    const item = delivery.giftItem as GiftItemForStore;
    const img = item.image;
    if (img && typeof img === 'object' && '_id' in img) {
      return fileBucketUrl(img._id, 'w200');
    }
  }
  return '';
};

export const getOrdererInfo = (delivery: GiftDeliveryForAdmin) => {
  if (typeof delivery.giftOrder !== 'object') {
    return { name: '-', phone: '-', purchasedAt: undefined };
  }
  const order = delivery.giftOrder as GiftDeliveryOrderInfo;
  return {
    name: order.bugo?.member?.fullName || order.receiverName || '-',
    phone: order.bugo?.member?.phoneNumber || order.receiverPhoneNumber || '-',
    purchasedAt: order.paymentDetail?.purchasedAt,
  };
};
